module.exports = __webpack_public_path__ + "img/助力零售.47cbfe7d.png";